<template>
  <v-container fluid class="property-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Property</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Property</p>
                        <v-text-field
                          class="mb-4"
                          type="Number"
                          v-model="new_property.propertyrank"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Property Rank"
                          persistent-hint
                          single-line hint="Enter the property rank">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_property.propertycode"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Property Code"
                          persistent-hint
                          single-line hint="Enter the property Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_property.propertyname"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Property Name"
                          persistent-hint
                          single-line hint="Enter the property name">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=property_types
                          v-model="new_property.propertytype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the property type">
                        </v-select>
                        <v-text-field
                          class="mb-4"
                          v-model="new_property.propertyinfo"
                          outlined
                          dense
                          placeholder="Property Info"
                          persistent-hint
                          single-line hint="Enter the property info">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="new_property.geolocation"
                          outlined
                          dense
                          placeholder="Geolocation"
                          persistent-hint
                          single-line hint="Enter the geolocation">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-textarea
                          outlined
                          v-model="new_property.propertyaddress"
                          rows="3"
                          label="Property Address"
                          hint="please enter the property address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="new_property.propertyphone"
                          outlined
                          dense
                          placeholder="Property Phone"
                          persistent-hint
                          single-line hint="Enter the property phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md=9>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/property/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertProperty()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      new_property: {},
      property_types: ['Apartment', 'Office', 'Medical Office', 'Retail', 'Industrial', 'Investment'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('Property', ['insertPropertyRequest','getPropertiesRequest']),
    checkError(){
      if(!this.new_property.propertyrank){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_property.propertycode){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_property.propertyname){
        this.haserrors = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_property.propertytype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertProperty() {
      console.log(this.new_property);
      await this.insertPropertyRequest(this.new_property)
      router.push('/property/list')
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    onFileChange(file) {
      if (!file) {return;}
      this.new_property.propertyimage = file;
      this.new_property.imagename = file.name;
      this.createImage(file);
    }
  },
  computed: {
    ...mapState('Property', ['isReceiving'])
  }

}
</script>

<style src="./Add.scss" lang="scss"></style>
